const nop = Symbol.for("nop");
export default nop;
